import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useSnackbar } from "notistack";

import { updateWebsite } from "api/endpoints/websites";

import { WebsiteDialog } from "layouts/LandPage/components/UI/WebsiteDialog";
import WebsiteInfoCard from "layouts/LandPage/components/UI/WebsiteInfoCard";

// Website-detail index page — the overview card plus the edit flow. Lifecycle
// actions (activate / notifications / delete) live on the Settings tab. Reads
// website + refreshWebsite from the WebsiteLayout outlet context.
function WebsiteDashboard() {
  const { website, refreshWebsite } = useOutletContext();
  const { enqueueSnackbar } = useSnackbar();

  const [editOpen, setEditOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleEditSubmit = async (data) => {
    setSubmitting(true);
    try {
      await updateWebsite(website.website_id, {
        name: data.name,
        domain: data.domain,
      });
      enqueueSnackbar("Website updated", { variant: "success" });
      setEditOpen(false);
      await refreshWebsite();
    } catch (err) {
      enqueueSnackbar(err?.normalizedMessage || "Failed to update website", { variant: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <WebsiteInfoCard website={website} onEdit={() => setEditOpen(true)} />

      <WebsiteDialog
        open={editOpen}
        website={website}
        onClose={() => setEditOpen(false)}
        onSubmit={handleEditSubmit}
        isLoading={submitting}
      />
    </>
  );
}

export default WebsiteDashboard;
